"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUnit = exports.defaultGetPollInterval = exports.default = exports.FormattedRelative = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactPageVisibility = require("react-page-visibility");
var _luxon = require("luxon");
var _locale = require("../const/locale");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var YEAR = 'year';
var QUARTER = 'quarter';
var MONTH = 'month';
var WEEK = 'week';
var DAY = 'day';
var HOUR = 'hour';
var MINUTE = 'minute';
var SECOND = 'second';
/*:: type Unit =
  | 'year'
  | 'quarter'
  | 'month'
  | 'week'
  | 'day'
  | 'hour'
  | 'minute'
  | 'second';*/
var selectUnit = exports.selectUnit = function selectUnit(dateString /*: string*/, options
/*: {
    padding?: number, // Don't use in combination with {round: false} because the decimal output will include the padding.
    round?: boolean // Rounds down by default.
  }*/
) /*: ?Unit*/{
  // If not a valid date string, return null.
  if (typeof dateString !== 'string') {
    return null;
  }
  var date = _luxon.DateTime.fromISO(dateString);

  // If not a valid date time, return null.
  if (!date.isValid) {
    return null;
  }
  var dateRelative = date.toRelative(options);
  if (dateRelative.includes(YEAR)) {
    return YEAR;
  }
  if (dateRelative.includes(QUARTER)) {
    return QUARTER;
  }
  if (dateRelative.includes(MONTH)) {
    return MONTH;
  }
  if (dateRelative.includes(WEEK)) {
    return WEEK;
  }
  if (dateRelative.includes(DAY)) {
    return DAY;
  }
  if (dateRelative.includes(HOUR)) {
    return HOUR;
  }
  if (dateRelative.includes(MINUTE)) {
    return MINUTE;
  }
  if (dateRelative.includes(SECOND)) {
    return SECOND;
  }
  return null;
};

// Back off polling frequency over time
var defaultGetPollInterval = exports.defaultGetPollInterval = function defaultGetPollInterval(pollCount /*: number*/) /*: number*/{
  // Every minute for 30 minutes
  if (pollCount < 30) {
    return 60000;
  }

  // Every 10 minutes after 30 minutes
  return 600000;
};
/*:: type Props = {
  getPollInterval?: (pollCount: number) => number,
  locale?: string,
  padding?: number,
  polling?: boolean,
  round?: boolean,
  style?: 'long' | 'short' | 'narrow',
  unit?:
    | 'years'
    | 'quarters'
    | 'months'
    | 'weeks'
    | 'days'
    | 'hours'
    | 'minutes'
    | 'seconds',
  value: string
};*/
var FormattedRelative = exports.FormattedRelative = (0, _react.memo)(function (props /*: Props*/) {
  var _props$getPollInterva = props.getPollInterval,
    getPollInterval = _props$getPollInterva === void 0 ? defaultGetPollInterval : _props$getPollInterva,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? _locale.LOCALE : _props$locale,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 0 : _props$padding,
    _props$polling = props.polling,
    polling = _props$polling === void 0 ? false : _props$polling,
    _props$round = props.round,
    round = _props$round === void 0 ? true : _props$round,
    _props$style = props.style,
    style = _props$style === void 0 ? 'long' : _props$style,
    unit = props.unit,
    dateString = props.value;
  var isVisible = (0, _reactPageVisibility.usePageVisibility)();
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pollCount = _useState2[0],
    setPollCount = _useState2[1];
  var pollInterval = getPollInterval(pollCount);

  // Update relative time based on poll interval.
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (isVisible && polling) {
        setPollCount(pollCount + 1);
      }
    }, pollInterval);
    return function () {
      return clearInterval(interval);
    };
  }, [isVisible, pollCount, polling, pollInterval]);

  // If not a valid date string, return null.
  if (typeof dateString !== 'string') {
    return null;
  }
  var date = _luxon.DateTime.fromISO(dateString);

  // If not a valid date time, return unformatted absolute date string.
  if (!date.isValid) {
    return /*#__PURE__*/_react.default.createElement("span", {
      title: dateString
    }, dateString);
  }
  var now = new Date().toISOString();
  var dateMillis = date.diff(_luxon.DateTime.fromISO(now)).valueOf();

  // For relative time less than 1 second, return now.
  if (typeof dateMillis === 'number' && dateMillis > -1000 && dateMillis < 1000) {
    return /*#__PURE__*/_react.default.createElement("span", {
      title: dateString
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "now",
      id: "formattedRelative.now"
    }));
  }
  var dateRelative = date.toRelative({
    locale: locale,
    padding: padding,
    round: round,
    style: style,
    unit: unit
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    title: dateString
  }, dateRelative);
});
FormattedRelative.displayName = 'FormattedRelative';
var _default = exports.default = FormattedRelative;
//# sourceMappingURL=FormattedRelative.js.map